/**
 * Created by Victor Rojo on 1/9/17.
 */
import { Component }                from '@angular/core';
import { FormGroup, FormControl,
         FormBuilder, Validators }  from '@angular/forms';
import { NotificationsService }     from 'angular2-notifications';

import { AuthService }  from '../auth.service';
import { Credential }   from "../credential";
import { I18NService }  from "../../i18n/i18n.service";

@Component({
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css'],
})
export class SignupComponent{

  signupForm: FormGroup;
  isBusy = false;
  public toastOptions = {
    position: ["top", "right"],
    timeOut: 3000,
    theClass: "bg-teal",
    lastOnBottom: true,
    showProgressBar: true,
    pauseOnHover: false,
  };

  constructor(private fb: FormBuilder,
              private authService: AuthService,
              private i18nService: I18NService,
              private notificationService: NotificationsService) {
    let pattern = /^[A-Za-z0-9\s\S\*]*$/;
    this.signupForm = fb.group({
      'accountName' : [null, Validators.compose([Validators.required, Validators.pattern(pattern)])],
      'login' : [null, Validators.compose([Validators.required, Validators.pattern(pattern)])],
      'password' : [null, Validators.compose([Validators.required, Validators.minLength(6), Validators.pattern(pattern)])],
      'email' : [null, Validators.compose([Validators.required, Validators.email])],
      'company' : [null],
      'address' : [null],
      'captcha': [null, Validators.required],
    })
  }

  signup():void{
    let user = {
      accountName: this.signupForm.controls["accountName"].value,
      login: this.signupForm.controls["login"].value,
      password: this.signupForm.controls["password"].value,
      email: this.signupForm.controls["email"].value,
      company: this.signupForm.controls["company"].value,
      address: this.signupForm.controls["address"].value
    };
    if ( this.signupForm.valid ) {
      this.isBusy = true;
      this.authService.signup(user)
        .then(res => {
          let credential = new Credential(this.signupForm.controls["login"].value, this.signupForm.controls["password"].value);
          this.authService.login(credential, false)
            .then( response => {
              this.isBusy = false;
            })
            .catch(error => {
              this.isBusy = false;
            });
          this.isBusy = false;
        })
        .catch( error => {
          this.isBusy = false;
          this.notificationService.error(
            this.i18nService.get("error"),
            this.i18nService.get("cantCreateAccount")
          );
        });
    }
  }
}
